module.exports = __webpack_public_path__ + "static/media/16.34239252.jpg";